module.exports = __webpack_public_path__ + "smirk1.c4f2a56b4eab38f1288f.jpg";


//////////////////
// WEBPACK FOOTER
// /var/www/capzool/temp/src/assets/images/smirk1.jpg
// module id = ../../../../../src/assets/images/smirk1.jpg
// module chunks = styles